import { PAGE_TEXT } from '../../lang';
import { SupervisorRoleTypes } from '../../../constants';
import { type SelectOption } from '../../../../../components';

const roleTypeText = PAGE_TEXT.SUPERVISOR_TEAM.ROLE_TYPE;

export const roleTypeOptions: SelectOption[] = [
  {
    label: roleTypeText.CO_SUPERVISOR,
    value: SupervisorRoleTypes.CO_SUPERVISOR,
  },
  {
    label: roleTypeText.EXTERNAL_CO_SUPERVISOR,
    value: SupervisorRoleTypes.EXTERNAL_CO_SUPERVISOR,
  },
  {
    // Dual External Chief Supervisor
    label: roleTypeText.EXTERNAL_CHIEF_DUAL,
    value: SupervisorRoleTypes.EXTERNAL_CHIEF_DUAL,
  },
  {
    // Joint External Chief Supervisor
    label: roleTypeText.EXTERNAL_CHIEF_JOINT,
    value: SupervisorRoleTypes.EXTERNAL_CHIEF_JOINT,
  },
];

// MOD 2024/09/26, for compatibility with older data in supervisor team section
export const supTeamRoleTypeMigrateMappings: Partial<
  Record<SupervisorRoleTypes, SupervisorRoleTypes>
> = {
  [SupervisorRoleTypes.CHIEF_SUPERVISOR]:
    SupervisorRoleTypes.EXTERNAL_CHIEF_JOINT,
  [SupervisorRoleTypes.EXTERNAL_CHIEF_SUPERVISOR]:
    SupervisorRoleTypes.EXTERNAL_CHIEF_DUAL,
};
